import { type Context, createContext, useContext } from 'react';

/** Do not import for non Atlassian studio */
export const SiteContext: Context<{
	siteId: string;
}> = createContext({
	siteId: '',
});

/** Do not import for non Atlassian studio */
export const useSiteContext = (): {
	siteId: string;
} => {
	const context = useContext(SiteContext);

	return context;
};
